import { useState, useEffect } from 'react';
import axios from 'axios';
import { providersApi, ProviderPublic } from '../services/providers';
import { getApiErrorMessage } from '../utils/errors';

export const useTopProviders = (limit: number = 5) => {
  const [providers, setProviders] = useState<ProviderPublic[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTopProviders = async () => {
      try {
        setLoading(true);
        const data = await providersApi.getTopProviders(limit);
        setProviders(data);
        setError(null);
      } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
          setError(getApiErrorMessage(err, 'Failed to fetch top providers'));
        } else if (err instanceof Error) {
          setError(err.message || 'An unexpected error occurred');
        } else {
          setError('An unexpected error occurred');
        }
        console.error('Error fetching top providers:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopProviders();
  }, [limit]);

  return { providers, loading, error };
};
